module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/18-81423767b42d32863008aedc3f85c141.jpg";